import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {ApplicationInterface, KeyValueInterface} from "../interfaces";
import CustomButton from "../../../components/CustomButton";
import CheckBox from "../../../components/Boxes/CheckBox";
import AlertIcon from "../../../components/Icons/AlertIcon";
import {scrollTop} from "../../../helpers/scrolling";

interface Props {
    application: ApplicationInterface;
    experiencesByIndustry: Array<KeyValueInterface>
    save: Function
}

const StepSix: React.FC<Props> = (props: Props) => {
    const translation = useTranslation();
    const { t, i18n } = translation;
    const [industries, setIndustries] = useState<Array<string>>(props.application.workedInIndustry);
    const [additionalIndustriesCoach, setAdditionalIndustriesCoach] =
      useState<string>(props.application.additionalIndustriesCoach)
    const [errors, setErrors] = useState<number>(0)
    const [triedSave, setTriedSave] = useState<boolean>(false)

    useEffect(() => {
        scrollTop()
    }, [])

    useEffect(() => {
        if (triedSave) {
            checkInput()
        }
    }, [industries])

    const checkInput = () => {
        let _errors = 0
        if (industries.length < 1) {
            _errors++
        }
        setErrors(_errors)
        return _errors
    }

    const save = () => {
        setTriedSave(true)
        if (checkInput() > 0) {
            console.log('There are errors')
            return
        }
        const _application: ApplicationInterface = props.application
        _application.workedInIndustry = industries
        _application.additionalIndustriesCoach = additionalIndustriesCoach
        props.save(_application)
    }

    const selectOption = (key: string) => {
        if (industries.indexOf(key) > -1) {
            // Deselect industry
            const _industries: Array<string> = []
            for (const industry of industries) {
                if (industry !== key) {
                    _industries.push(industry)
                }
            }
            setIndustries(_industries)
        } else {
            const _industries = [...industries]
            _industries.push(key)
            setIndustries(_industries)
        }
    }

    const renderAreas = (start: number, end: number) => {
        return (
          <div>
              {
                  props.experiencesByIndustry.slice(start, end).map((industry: KeyValueInterface, index: number) => (
                    <div key={"industry_" + index} className="mt-3 flex items-center"
                         onClick={() => selectOption(industry.key)}>
                        <CheckBox checked={industries.indexOf(industry.key) !== -1}/>
                        <div className="text-sm ml-2">{industry.value}</div>
                    </div>
                  ))
              }
          </div>
        )
    }

    return (
      <>
          <div className="mt-6 text-xl font-medium">Your industry experience</div>

          <div className="mt-4 text-neutral-400">
              Please select industries outside coaching where you've worked before.
          </div>

          <div className="mt-6 text-lg font-medium">
              Technology and Innovation
          </div>

          {renderAreas(0, 3)}

          <hr className="mt-4 border-neutral-600"/>

          <div className="mt-6 text-lg font-medium">
              Finance and Professional Services
          </div>

          {renderAreas(3, 8)}

          <hr className="mt-4 border-neutral-600"/>

          <div className="mt-6 text-lg font-medium">
              Industry and Manufacture
          </div>

          {renderAreas(8, 12)}

          <hr className="mt-4 border-neutral-600"/>

          <div className="mt-6 text-lg font-medium">
              Consumer Goods and Services
          </div>

          {renderAreas(12, 17)}

          <hr className="mt-4 border-neutral-600"/>

          <div className="mt-6">Additional industries</div>
          <input value={additionalIndustriesCoach}
                 className="z-input mt-2"
                 onChange={(e) => setAdditionalIndustriesCoach(e.target.value)}/>


          {
            (triedSave && errors > 0) &&
              <div className="mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center">
                  <AlertIcon aria-label="Error" className="text-cherry-500!"/>
                  <div className="ml-2 font-medium">Please select experience level for at least one coaching area</div>
              </div>
          }


          <CustomButton className="mt-6" onClick={() => save()}>
              Next
          </CustomButton>
      </>
    )
}

export default StepSix